<template>
  <v-app id="app">

    <div id="main-background-gradient"></div>

    <!--add 'app' to nav-bar if the navbar should be fixed at top of page-->
    <!--<nav-bar></nav-bar>-->

    <!-- Sizes your content based upon application components -->
    <v-main>
      <router-view></router-view>
    </v-main>


    <!--add 'app' to footer if the navbar should be fixed at top of page-->
    <v-footer >
      <div class="footer">Powered by Espy Analytics</div>
    </v-footer>
  </v-app>







</template>


<style scoped lang="scss">
  @import 'assets/styles/variables/Variables';

  #app{
    background: none;
  }


  #main-container{
    /*background: none;*/
    padding: 0;
  }


  #main-background-gradient{
    position: fixed;
    height: 100%;
    /*min-height: 1000px;*/
    width: 100%;
    margin: 0;

    //color: $color-white;
    background: $color-app-background;
    z-index: -1;
    /*opacity: 0.5;*/

  }

  .footer{
    text-align: center;
    width:100%;
  }

</style>

<style>
:root{
   --color-primary: #6500E9;

   --light-bg: #ffffff;
   --light-bg2: #e0e0e0;
   --light-font-color: #1c1c1c;
   --light-font-color-primary: #8848ff;


   --dark-bg: #0d0d0d;
   --dark-bg-lighten-1: #1a1923;
   --dark-bg-lighten-2: #2c2a3b;
   --dark-bg-lighten-3: #3f3d54;
   --dark-font-color: white;
   --dark-font-color-primary: #8848ff;

   --color-good: #1FFF27;
   --color-bad: #FF0000;
   --color-ok: yellow;

}
</style>

<script>
   import navBar from '@/components/navBar.vue'

export default {
  name: 'App',

  components: {
     navBar
  },

  data: () => ({
    //
  }),
   created(){

   }
};
</script>
